// Page Mon compte (lot B10) : le registre du compte. Qui tu es, ce que ton compte ouvre, comment changer ton mot
// de passe, comment partir. Trois surfaces du lot partagent ce module : les helpers de formulaire (saisie gardée
// d'un redessin à l'autre, erreur posée sous le champ fautif) servent aussi aux pages publiques.
//
// Le geste du lot : rien ne se perd. Chaque réponse du serveur redessine tout #main-content ; le module relit les
// champs juste avant de rendre et les repose dans le balisage neuf, mots de passe compris. La seule fenêtre est la
// confirmation de suppression, parce qu'elle est irréversible — et la saisie est encore là si on annule.
import { html } from '../../core/html.js';
import { state } from '../../core/store.js';
import { actions } from '../../core/actions.js';
import { ico } from '../icones.js';
import { toast } from '../components/toast.js';

// --- saisies gardées d'un redessin à l'autre (le serveur répond, renderContent remplace la page)
// memoriser() est appelé par le rendu, avant que innerHTML remplace la page : les champs de l'ancien balisage
// sont encore là, on y relit ce qui est tapé. Après un succès, oublier() arme un vidage que le prochain
// memoriser consomme — sinon il relirait le mot de passe dans le vieux DOM et le reposerait dans le neuf.
var saisies = {}, aVider = null;
export function memoriser(ids) {
    var vider = aVider; aVider = null;
    ids.forEach(function(id) {
        if (vider && vider.indexOf(id) !== -1) { saisies[id] = ''; return; }
        var el = document.getElementById(id); if (el) saisies[id] = el.value;
    });
}
export function garde(id) { return saisies[id] || ''; }
export function oublier(ids) { ids.forEach(function(id) { saisies[id] = ''; }); aVider = ids.slice(); }
// Quitter la surface, c'est tout perdre — et c'est voulu. La promesse du lot est de ne rien perdre PENDANT une
// tâche, pas entre deux visites : quand le champ n'est plus dans le DOM, memoriser() ne peut plus le relire et
// garderait sa valeur précédente, que champ() reposerait en clair dans l'attribut value au retour sur /compte.
// Le message de succès subirait le même sort (« Mot de passe changé. » réaffiché sans qu'aucune action n'ait eu
// lieu). Appelé par le rendu de la coquille quand la page rendue change (src/legacy/app.js, renderContent).
export function oublierTout() {
    saisies = {}; aVider = null;
    window.compteEtat = { message: '', erreur: '', busy: false, fait: false };
}
export function valeur(id) { var el = document.getElementById(id); return el ? el.value : ''; }
export function focaliser(sel) { var el = document.querySelector(sel); if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) {} } }
// Après un redessin, le focus retombe sur body : on le repose à l'image suivante, et seulement si personne d'autre
// ne l'a pris entre-temps (quelqu'un qui tape déjà dans un champ garde son champ).
export function refocusSiLibre(sel) {
    requestAnimationFrame(function() { if (!document.activeElement || document.activeElement === document.body) focaliser(sel); });
}
export function etat() {
    var e = window.compteEtat || (window.compteEtat = { message: '', erreur: '', busy: false, fait: false });
    return e;
}
// Où poser window.compteEtat.erreur : le champ que nos validations ont désigné, sinon d'après le message du
// serveur, sinon en tête de carte. `regles` : [[motif, id], …] propres à la carte qui appelle.
export function ouErreur(regles, defaut) {
    var e = etat();
    if (!e.erreur) return null;
    if (e.champ) return e.champ;
    if (/injoignable|réseau|indisponible|serveur|réessa/i.test(e.erreur)) return 'form';
    for (var i = 0; i < regles.length; i++) if (regles[i][0].test(e.erreur)) return regles[i][1];
    return defaut || 'form';
}

// --- le champ du lot : libellé au-dessus, saisie de 44 px, aide ou erreur en dessous, saisie repeuplée
export function champ(o) {
    var invalide = !!o.invalide;
    return html`<div class="champ"${invalide ? html` data-invalide` : ''}>
        <label for="${o.id}">${o.label}</label>
        <input id="${o.id}" class="saisie" type="${o.type || 'password'}" name="${o.nom || o.id}" autocomplete="${o.autocomplete || 'off'}" value="${garde(o.id)}"
            enterkeyhint="${o.enterkeyhint || 'go'}" data-input-action="compteSaisie"${invalide ? html` aria-invalid="true"` : ''}${invalide ? html` aria-describedby="${o.id}-erreur"` : (o.aide ? html` aria-describedby="${o.id}-aide"` : '')}>
        ${o.aide && !invalide ? html`<p class="aide" id="${o.id}-aide">${o.aide}</p>` : ''}
        ${invalide ? html`<p class="erreur" id="${o.id}-erreur" role="alert">${ico('warning-circle', { taille: 14 })}<span>${etat().erreur}</span></p>` : ''}
    </div>`;
}
// L'erreur qui ne vise aucun champ (serveur injoignable) : en tête de la carte, icône et mot.
export function alerte(texte) {
    return html`<p class="reg-alerte" role="alert">${ico('warning-circle', { taille: 18 })}<span>${texte}</span></p>`;
}
export function succes(texte) {
    return html`<p class="reg-succes" role="status">${ico('check-circle', { taille: 18 })}<span>${texte}</span></p>`;
}
// Une ligne de registre : libellé à gauche, valeur à droite, un filet entre deux.
export function ligne(libelle, valeurHtml) {
    return html`<div class="reg-ligne"><dt>${libelle}</dt><dd>${valeurHtml}</dd></div>`;
}

// --- squelette : la forme de la page avant que la session soit lue
export function squeletteCompte() {
    return html`<div class="squelettes" aria-hidden="true">
        <div class="jour-entete"><div class="jour-entete-texte"><div class="squelette squelette-titre" style="width:220px"></div><div class="squelette squelette-ligne" style="width:320px"></div></div></div>
        <div class="squelette squelette-ligne" style="width:70%"></div><div class="squelette squelette-ligne" style="width:52%"></div><div class="squelette squelette-ligne" style="width:64%"></div>
        <div class="squelette squelette-bloc" style="margin-top:24px;height:200px"></div>
        <div class="squelette squelette-bloc" style="height:160px"></div>
    </div>`;
}

function etatIA(u) {
    var ab = u.abonnement, fin = ab && ab.fin ? window.formatDateFr(String(ab.fin).slice(0, 10)) : '';
    if (u.admin) return { classe: 'puce-ok', mot: 'Incluses', suite: 'ton rôle les ouvre toutes' };
    if (u.ia) return { classe: 'puce-ok', mot: 'Abonnement actif', suite: fin ? 'jusqu\'au ' + fin : '' };
    return { classe: '', mot: 'Non abonné', suite: '' };
}

export function renderCompte() {
    memoriser(['mdp-ancien', 'mdp-nouveau', 'mdp-suppr']);
    var u = state.user || {}, e = etat();
    var ia = etatIA(u);
    // L'erreur du mot de passe : « actuel / incorrect » désigne l'ancien, « 8 caractères » le nouveau.
    var ouMdp = e.champ === 'mdp-suppr' ? null : ouErreur([[/actuel|ancien|incorrect|identifiant/i, 'mdp-ancien'], [/8 caractères|nouveau|trop court|faible/i, 'mdp-nouveau']], 'mdp-ancien');
    var ouSup = e.champ === 'mdp-suppr' ? 'mdp-suppr' : null;
    var occupeMdp = e.busy && e.quoi !== 'suppr', occupeSup = e.busy && e.quoi === 'suppr';

    return html`<div class="cpt fade-in">
        <header class="jour-entete">
            <div class="jour-entete-texte">
                <h1 class="jour-date">Mon compte</h1>
                <p class="cpt-resume">Ton identité, ton mot de passe, et la porte de sortie. Rien d'autre ne se règle ici : le planning se règle dans Planifier.</p>
            </div>
        </header>

        <section class="cpt-section" aria-labelledby="cpt-identite-titre">
            <h2 id="cpt-identite-titre">Identité</h2>
            <dl class="reg">
                ${ligne('Adresse', html`<span class="reg-valeur">${ico('at', { taille: 16 })}<span class="reg-fort">${u.email || '—'}</span></span>`)}
                ${ligne('Rôle', u.admin
                    ? html`<span class="puce puce-accent">Administrateur</span>`
                    : html`<span class="puce">Utilisateur</span>`)}
                ${ligne('Fonctions IA', html`<span class="reg-valeur"><span class="puce ${ia.classe}">${ia.mot}</span>${ia.suite ? html`<span class="reg-note num">${ia.suite}</span>` : ''}<a class="reg-lien" href="${window.pageUrl('abonnement')}">${u.admin || u.ia ? 'Voir le détail' : 'Voir l\'abonnement'}</a></span>`)}
                ${ligne('Tes données', html`<span class="reg-valeur"><span class="reg-texte">Planning, résultats et préférences sont enregistrés sur le serveur. Le planning s'exporte en fichier <span class="num">.json</span> depuis le menu du planning, dans le rail d'outils.</span></span>`)}
            </dl>
        </section>

        <section class="carte carte-corps cpt-carte" aria-labelledby="cpt-mdp-titre">
            <div class="cpt-carte-tete">
                <h2 id="cpt-mdp-titre">${ico('key', { taille: 20 })}Changer de mot de passe</h2>
                <p class="cpt-aide">Il te faut l'ancien pour poser le nouveau. Tu restes connecté sur cet appareil.</p>
            </div>
            ${e.message ? succes(e.message) : ''}
            ${ouMdp === 'form' ? alerte(e.erreur) : ''}
            <form id="cpt-mdp-form" class="cpt-form" method="post" novalidate${occupeMdp ? html` aria-busy="true"` : ''}>
                ${champ({ id: 'mdp-ancien', label: 'Mot de passe actuel', autocomplete: 'current-password', enterkeyhint: 'next', invalide: ouMdp === 'mdp-ancien' })}
                ${champ({ id: 'mdp-nouveau', label: 'Nouveau mot de passe', autocomplete: 'new-password', aide: '8 caractères minimum.', invalide: ouMdp === 'mdp-nouveau' })}
                <button id="cpt-mdp-envoyer" type="submit" class="btn btn-primaire cpt-envoyer"${occupeMdp ? html` aria-busy="true" disabled` : ''}>Changer le mot de passe</button>
            </form>
        </section>

        <section class="carte carte-corps cpt-carte cpt-fin" aria-labelledby="cpt-suppr-titre">
            <div class="cpt-carte-tete">
                <h2 id="cpt-suppr-titre">${ico('trash-simple', { taille: 20 })}Supprimer mon compte</h2>
            </div>
            <dl class="reg reg-serre">
                ${ligne('Ce qui disparaît', 'Le compte, le planning, les séances faites, les résultats aux QCM, les préférences, et l\'abonnement — résilié immédiatement, sans remboursement de la période en cours.')}
                ${ligne('Ce qui reste', 'Les fiches, les podcasts et les QCM partagés : ils ne t\'appartiennent pas et servent aux autres comptes.')}
                ${ligne('Revenir en arrière', 'Impossible. Exporte ton planning avant, si tu veux le garder.')}
            </dl>
            ${ouSup === 'mdp-suppr' && e.erreur && /injoignable|réseau|indisponible/i.test(e.erreur) ? alerte(e.erreur) : ''}
            <form id="cpt-suppr-form" class="cpt-form cpt-form-fin" method="post" novalidate${occupeSup ? html` aria-busy="true"` : ''}>
                ${champ({ id: 'mdp-suppr', label: 'Mot de passe, pour confirmer', autocomplete: 'current-password', invalide: ouSup === 'mdp-suppr' })}
                <button id="cpt-suppr-envoyer" type="submit" class="btn btn-danger cpt-envoyer"${occupeSup ? html` aria-busy="true" disabled` : ''}>${ico('trash-simple', { taille: 18 })}Supprimer mon compte</button>
            </form>
        </section>
    </div>`;
}

// --- actions déléguées
function poserErreur(champId, message) {
    var e = etat();
    e.erreur = message; e.message = ''; e.champ = champId; e.busy = false; e.quoi = null;
    window.renderContent();
    focaliser('#' + (champId === 'form' ? 'mdp-ancien' : champId));
}

actions.changerMotDePasse = function() {
    var e = etat();
    if (e.busy) return;
    var ancien = valeur('mdp-ancien'), nouveau = valeur('mdp-nouveau');
    saisies['mdp-ancien'] = ancien; saisies['mdp-nouveau'] = nouveau;
    e.erreur = ''; e.message = ''; e.champ = null;
    if (!ancien) return poserErreur('mdp-ancien', 'Mot de passe actuel manquant.');
    if (nouveau.length < 8) return poserErreur('mdp-nouveau', 'Nouveau mot de passe : 8 caractères minimum.');
    if (nouveau === ancien) return poserErreur('mdp-nouveau', 'Le nouveau mot de passe est le même que l\'ancien.');
    e.busy = true; e.quoi = 'mdp';
    var b = document.getElementById('cpt-mdp-envoyer');
    if (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; }
    window.syncWithServer('password_change', { ancien: ancien, nouveau: nouveau }, function(d) {
        e.busy = false; e.quoi = null;
        if (d && d.success) {
            e.message = d.message || 'Mot de passe changé.'; e.erreur = ''; e.champ = null;
            oublier(['mdp-ancien', 'mdp-nouveau']);
            window.renderContent();
            toast('Mot de passe changé.', { icone: 'check-circle' });
            return;
        }
        e.erreur = (d && d.message) || 'Serveur injoignable : le mot de passe n\'a pas été changé.';
        e.champ = null;   // la place de l'erreur se déduit du message du serveur
        window.renderContent();
        var el = document.querySelector('.cpt-carte [data-invalide] input');
        if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (x) {} }
    });
};

actions.supprimerCompte = function() {
    var e = etat();
    if (e.busy) return;
    var mdp = valeur('mdp-suppr');
    saisies['mdp-suppr'] = mdp;
    e.erreur = ''; e.message = ''; e.champ = null;
    if (!mdp) return poserErreur('mdp-suppr', 'Indique ton mot de passe pour confirmer.');
    // La seule fenêtre du lot : l'action est irréversible, elle mérite d'interrompre. La saisie est gardée :
    // annuler ne coûte rien.
    window.dialogue.confirmer({
        titre: 'Supprimer définitivement ton compte ?',
        message: 'Le compte, le planning, les séances faites, les résultats et les préférences sont effacés, et l\'abonnement est résilié immédiatement. Les fiches, podcasts et QCM partagés restent en place. On ne peut pas revenir en arrière.',
        ok: 'Supprimer mon compte', annuler: 'Annuler', danger: true,
    }).then(function(ok) {
        if (!ok) { focaliser('#mdp-suppr'); return; }
        e.busy = true; e.quoi = 'suppr'; e.champ = 'mdp-suppr';
        var b = document.getElementById('cpt-suppr-envoyer');
        if (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; }
        window.syncWithServer('account_delete', { password: mdp }, function(d) {
            e.busy = false; e.quoi = null;
            if (d && d.success) {
                oublier(['mdp-ancien', 'mdp-nouveau', 'mdp-suppr']);
                try { localStorage.clear(); } catch (x) {}
                location.assign(window.routeUrl('accueil'));
                return;
            }
            e.erreur = (d && d.message) || 'Serveur injoignable : le compte n\'a pas été supprimé.';
            e.champ = 'mdp-suppr';
            window.renderContent();
            focaliser('#mdp-suppr');
        });
    });
};

// Corriger un champ retire son erreur sur place : pas de redessin, la saisie continue.
actions.compteSaisie = function(el) {
    var c = el && el.closest ? el.closest('.champ') : null;
    if (c && c.hasAttribute('data-invalide')) {
        c.removeAttribute('data-invalide'); el.removeAttribute('aria-invalid'); el.removeAttribute('aria-describedby');
        var p = c.querySelector('.erreur'); if (p) p.remove();
        var e = etat(); e.erreur = ''; e.champ = null;
    }
    if (el && el.id) saisies[el.id] = el.value;
};

// Entrée dans un champ soumet son formulaire (soumission implicite du navigateur) : c'est nous qui l'envoyons.
document.addEventListener('submit', function(ev) {
    var f = ev.target;
    if (!f || !f.id) return;
    if (f.id === 'cpt-mdp-form') { ev.preventDefault(); actions.changerMotDePasse(); }
    else if (f.id === 'cpt-suppr-form') { ev.preventDefault(); actions.supprimerCompte(); }
});

window.renderCompte = renderCompte;
window.squeletteCompte = squeletteCompte;
window.compteOublierTout = oublierTout;
